/* Mini cart refresh via Section Rendering API (server-rendered cart HTML) */

var technixiaMoneyFormat = "Liquid error: This liquid context does not allow includes.";

window.technixiaFormatCartMoney = function(cents) {
  var format = technixiaMoneyFormat || (window.Shopify && Shopify.money_format) || '₹';
  if (!format || !/\{\{\s*\w+\s*\}\}/.test(format)) {
    format = '₹';
  }

  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var amount = (Number(cents || 0) / 100).toFixed(2);
  return '₹' + amount;
};

window.technixiaGetCartRoot = function() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') {
    root += '/';
  }
  return root;
};

window.technixiaHideAllTooltips = function() {
  if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(el) {
      var instance = bootstrap.Tooltip.getInstance(el);
      if (instance) {
        instance.hide();
      }
    });
  }

  document.querySelectorAll('.tooltip').forEach(function(tip) {
    tip.classList.remove('show');
    tip.remove();
  });
};

window.technixiaOpenMiniCart = function() {
  if (typeof window.technixiaHideAllTooltips === 'function') {
    window.technixiaHideAllTooltips();
  }
  if (typeof jQuery === 'undefined') return;
  jQuery('.mini-cart').addClass('show');
  jQuery('.mm-fullscreen-bg').addClass('active');
  jQuery('body').addClass('hidden');
};

window.technixiaRefreshMiniCart = function(callback) {
  var root = technixiaGetCartRoot();

  fetch(root + '?sections=mini-cart-drawer')
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Section request failed');
      }
      return response.json();
    })
    .then(function(data) {
      var sectionHtml = data['mini-cart-drawer'];
      if (!sectionHtml) {
        throw new Error('Mini cart section HTML missing');
      }

      var temp = document.createElement('div');
      temp.innerHTML = sectionHtml;
      var newMiniCart = temp.querySelector('.mini-cart');
      var currentMiniCart = document.querySelector('.mini-cart');

      if (!newMiniCart || !currentMiniCart) {
        throw new Error('Mini cart element not found');
      }

      var wasOpen = currentMiniCart.classList.contains('show');
      currentMiniCart.innerHTML = newMiniCart.innerHTML;

      if (wasOpen) {
        currentMiniCart.classList.add('show');
      }

      technixiaUpdateHeaderCartTotal();

      if (typeof window.technixiaInitQtyControls === 'function') {
        window.technixiaInitQtyControls();
      }

      if (typeof window.technixiaBindMiniCartQtyControls === 'function') {
        window.technixiaBindMiniCartQtyControls();
      }

      if (typeof callback === 'function') {
        callback();
      }
    })
    .catch(function(error) {
      console.error('Mini cart refresh failed:', error);
      if (typeof callback === 'function') {
        callback();
      }
    });
};

window.technixiaUpdateHeaderCartTotal = function() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      var formattedTotal = technixiaFormatCartMoney(cart.total_price);
      document.querySelectorAll('.shopping-cart .total-price').forEach(function(el) {
        el.textContent = ' (' + formattedTotal + ')';
      });
    })
    .catch(function(error) {
      console.error('Header cart total update failed:', error);
    });
};

window.technixiaRemoveCartItem = function(variantOrLineId) {
  return window.technixiaChangeCartLine(variantOrLineId, 0);
};

if (typeof Shopify !== 'undefined') {
  Shopify.removeItem = function(variantId) {
    return window.technixiaRemoveCartItem(variantId);
  };
}

window.technixiaChangeCartLine = function(lineKey, quantity, options) {
  options = options || {};
  var root = technixiaGetCartRoot();

  return fetch(root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    body: new URLSearchParams({
      id: String(lineKey),
      quantity: String(quantity)
    }).toString()
  })
    .then(function(response) {
      return response.json().then(function(data) {
        if (!response.ok) {
          throw data;
        }
        return data;
      });
    })
    .then(function(cart) {
      technixiaUpdateHeaderCartTotal();

      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return cart;
      }

      if (typeof window.technixiaRefreshMiniCart === 'function') {
        window.technixiaRefreshMiniCart(function() {
          if (options.openMiniCart) {
            technixiaOpenMiniCart();
          }
        });
      } else if (options.openMiniCart) {
        technixiaOpenMiniCart();
      }

      return cart;
    })
    .catch(function(error) {
      console.error('Cart quantity update failed:', error);
      throw error;
    });
};

window.technixiaGetMiniCartLineKey = function(productQuantityEl) {
  if (!productQuantityEl) return '';
  return (
    productQuantityEl.getAttribute('data-line-key') ||
    productQuantityEl.getAttribute('data-variant') ||
    ''
  );
};

window.technixiaBindProductPageQtyControls = function() {
  if (window.technixiaProductPageQtyBound) return;
  window.technixiaProductPageQtyBound = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-product-qty] .qtybutton');
    if (!button || button.disabled || button.closest('.cart-plus-minus.disabled')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var wrap = button.closest('.cart-plus-minus');
    if (!wrap) return;

    var input = wrap.querySelector('input[name="quantity"]');
    if (!input || input.disabled) return;

    var oldValue = parseInt(input.value, 10);
    if (!Number.isFinite(oldValue) || oldValue < 1) {
      oldValue = 1;
    }

    var newVal = button.classList.contains('inc')
      ? oldValue + 1
      : Math.max(1, oldValue - 1);

    input.value = String(newVal);

    var form = button.closest('form') || technixiaGetProductPageForm();
    if (form && typeof window.technixiaSyncProductPageCart === 'function') {
      window.technixiaSyncProductPageCart(form, newVal, { openMiniCart: false });
    }
  }, true);
};

window.technixiaBindMiniCartQtyControls = function() {
  if (window.technixiaMiniCartQtyBound) return;
  window.technixiaMiniCartQtyBound = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.mini-cart .qtybutton');
    if (!button || button.disabled || button.closest('.cart-plus-minus.disabled')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var wrap = button.closest('.cart-plus-minus');
    var productQuantity = button.closest('.product-quantity');
    if (!wrap || !productQuantity) return;

    var input = wrap.querySelector('input[name="quantity"]');
    if (!input || input.disabled) return;

    var lineKey = technixiaGetMiniCartLineKey(productQuantity);
    if (!lineKey) return;

    var oldValue = parseInt(input.value, 10);
    if (!Number.isFinite(oldValue) || oldValue < 1) {
      oldValue = 1;
    }

    var newVal = button.classList.contains('inc')
      ? oldValue + 1
      : Math.max(1, oldValue - 1);

    input.value = String(newVal);
    wrap.classList.add('is-updating');

    technixiaChangeCartLine(lineKey, newVal)
      .catch(function() {
        if (typeof window.technixiaRefreshMiniCart === 'function') {
          window.technixiaRefreshMiniCart();
        }
      })
      .finally(function() {
        wrap.classList.remove('is-updating');
      });
  }, true);

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input.matches('.mini-cart input[name="quantity"]') || input.disabled) {
      return;
    }

    var productQuantity = input.closest('.product-quantity');
    var lineKey = technixiaGetMiniCartLineKey(productQuantity);
    if (!lineKey) return;

    var newVal = parseInt(input.value, 10);
    if (!Number.isFinite(newVal) || newVal < 1) {
      newVal = 1;
      input.value = String(newVal);
    }

    technixiaChangeCartLine(lineKey, newVal).catch(function() {
      if (typeof window.technixiaRefreshMiniCart === 'function') {
        window.technixiaRefreshMiniCart();
      }
    });
  });
};

window.technixiaGetProductPageForm = function() {
  return document.getElementById('add-item-form');
};

window.technixiaGetProductPageQuantityInput = function(formEl) {
  var form = formEl || technixiaGetProductPageForm();
  if (!form) return null;
  return form.querySelector('[data-product-qty] [name="quantity"], .product-qty-input[name="quantity"], [name="quantity"]');
};

window.technixiaGetProductPageVariantId = function(formEl) {
  var form = formEl || technixiaGetProductPageForm();
  if (!form) return null;
  var variantInput = form.querySelector('[name="id"]');
  return variantInput && variantInput.value ? String(variantInput.value) : null;
};

window.technixiaFindCartLineForVariant = function(cart, variantId) {
  if (!cart || !cart.items || !variantId) return null;
  return cart.items.find(function(item) {
    return String(item.variant_id) === String(variantId);
  }) || null;
};

window.technixiaLoadProductPageQtyFromCart = function(formEl) {
  var form = formEl || technixiaGetProductPageForm();
  if (!form) return Promise.resolve();

  var variantId = technixiaGetProductPageVariantId(form);
  var quantityInput = technixiaGetProductPageQuantityInput(form);
  var productQtyWrap = form.querySelector('[data-product-qty]');

  if (!variantId || !quantityInput) return Promise.resolve();

  return fetch(technixiaGetCartRoot() + 'cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      var lineItem = technixiaFindCartLineForVariant(cart, variantId);

      if (lineItem) {
        quantityInput.value = lineItem.quantity;
        if (productQtyWrap) {
          productQtyWrap.setAttribute('data-cart-line-key', lineItem.key);
        }
      } else {
        quantityInput.value = 1;
        if (productQtyWrap) {
          productQtyWrap.removeAttribute('data-cart-line-key');
        }
      }

      return cart;
    })
    .catch(function(error) {
      console.error('Product page cart quantity load failed:', error);
    });
};

window.technixiaProductPageCartSyncChain = Promise.resolve();

window.technixiaSyncProductPageCart = function(formEl, quantity, options) {
  options = options || {};
  var form = formEl || technixiaGetProductPageForm();

  if (!form) {
    return Promise.reject(new Error('Product form not found'));
  }

  quantity = parseInt(quantity, 10);
  if (!Number.isFinite(quantity) || quantity < 1) {
    quantity = 1;
  }

  var quantityInput = technixiaGetProductPageQuantityInput(form);
  var productQtyWrap = form.querySelector('[data-product-qty]');
  var variantId = technixiaGetProductPageVariantId(form);

  if (!variantId) {
    return Promise.reject(new Error('Variant not selected'));
  }

  if (quantityInput) {
    quantityInput.value = quantity;
  }

  if (productQtyWrap) {
    productQtyWrap.classList.add('is-syncing');
  }

  var syncTask = function() {
    var root = technixiaGetCartRoot();

    return fetch(root + 'cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var lineItem = technixiaFindCartLineForVariant(cart, variantId);

        if (lineItem) {
          if (productQtyWrap) {
            productQtyWrap.setAttribute('data-cart-line-key', lineItem.key);
          }

          return technixiaChangeCartLine(lineItem.key, quantity, options);
        }

        var formData = new FormData();
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        })
          .then(function(response) {
            return response.json().then(function(data) {
              if (!response.ok) {
                throw data;
              }
              return data;
            });
          })
          .then(function(lineItem) {
            if (productQtyWrap && lineItem && lineItem.key) {
              productQtyWrap.setAttribute('data-cart-line-key', lineItem.key);
            }

            technixiaUpdateHeaderCartTotal();

            if (typeof window.technixiaRefreshMiniCart === 'function') {
              return new Promise(function(resolve) {
                window.technixiaRefreshMiniCart(function() {
                  if (options.openMiniCart) {
                    technixiaOpenMiniCart();
                  }
                  resolve(lineItem);
                });
              });
            }

            if (options.openMiniCart) {
              technixiaOpenMiniCart();
            }

            return lineItem;
          });
      })
      .finally(function() {
        if (productQtyWrap) {
          productQtyWrap.classList.remove('is-syncing');
        }
      });
  };

  window.technixiaProductPageCartSyncChain = window.technixiaProductPageCartSyncChain
    .then(syncTask)
    .catch(function(error) {
      console.error('Product page cart sync failed:', error);
      if (typeof window.technixiaLoadProductPageQtyFromCart === 'function') {
        window.technixiaLoadProductPageQtyFromCart(form);
      }
      throw error;
    });

  return window.technixiaProductPageCartSyncChain;
};

if (typeof Shopify !== 'undefined') {
  Shopify.addItemFromForm = function(form, callback, errorCallback) {
    var formEl = typeof form === 'string'
      ? document.getElementById(form.replace(/^#/, ''))
      : form;

    if (!formEl) {
      console.error('Add to cart form not found.');
      if (typeof errorCallback === 'function') {
        errorCallback(new Error('Form not found'));
      }
      return Promise.reject(new Error('Form not found'));
    }

    var formData = new FormData(formEl);
    var quantityInput = technixiaGetProductPageQuantityInput(formEl);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!Number.isFinite(quantity) || quantity < 1) {
      quantity = 1;
    }

    if (quantityInput) {
      quantityInput.value = quantity;
    }

    formData.set('quantity', String(quantity));

    var variantInput = formEl.querySelector('[name="id"]');
    if (variantInput && variantInput.value) {
      formData.set('id', variantInput.value);
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            throw data;
          }
          return data;
        });
      })
      .then(function(lineItem) {
        if (typeof Shopify.onItemAdded === 'function') {
          Shopify.onItemAdded(lineItem);
        }
        if (typeof callback === 'function') {
          callback(lineItem);
        }
        return lineItem;
      })
      .catch(function(error) {
        console.error('Add to cart failed:', error);
        if (typeof errorCallback === 'function') {
          errorCallback(error);
        }
        throw error;
      });
  };

  Shopify.onItemAdded = function() {
    technixiaRefreshMiniCart();
  };

  Shopify.onCartUpdate = function() {
    technixiaRefreshMiniCart();
  };
}

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.technixiaBindProductPageQtyControls === 'function') {
    window.technixiaBindProductPageQtyControls();
  }

  if (typeof window.technixiaBindMiniCartQtyControls === 'function') {
    window.technixiaBindMiniCartQtyControls();
  }

  if (document.querySelector('.mini-cart') || document.querySelector('.shopping-cart .total-price')) {
    technixiaUpdateHeaderCartTotal();
  }

  var productForm = technixiaGetProductPageForm();
  if (!productForm) return;

  technixiaLoadProductPageQtyFromCart(productForm);

  var productSelect = document.getElementById('productSelect');
  if (productSelect) {
    productSelect.addEventListener('change', function() {
      technixiaLoadProductPageQtyFromCart(productForm);
    });
  }

  var productQtyInput = technixiaGetProductPageQuantityInput(productForm);
  if (productQtyInput) {
    productQtyInput.addEventListener('change', function() {
      var quantity = parseInt(productQtyInput.value, 10);
      if (!Number.isFinite(quantity) || quantity < 1) {
        quantity = 1;
        productQtyInput.value = quantity;
      }

      technixiaSyncProductPageCart(productForm, quantity, { openMiniCart: true });
    });
  }
});
